<template>
  <div id="popup"
       @focus="handleFocus"
       @focusout="handleFocusOut"
       tabindex="0"
       ref="frame"
       v-if="isSidebarActiveLocal" :class="isSidebarActiveLocal ? 'active' : ''">

    <div class="popup-cont">
      <h2 class="popup-heading">{{dataProp ? 'Save' : 'ADD NEW'}} RESTAURANT</h2>
      <div class="popup-item">
        <h4>Restaurant</h4>
        <input type="text" class="pop-input" v-model="name" placeholder="Name" name="Name" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
      </div>
      <div class="popup-item">
        <h4>Location</h4>
        <input type="text" class="pop-input" v-model="location" placeholder="Location" name="Location" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Location')">{{ errors.first('Location') }}</span>
      </div>
      <div class="popup-item">
        <h4>Google Star</h4>
        <input type="text" class="pop-input" v-model="google_star" placeholder="Google Star" name="Google Star" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Google Star')">{{ errors.first('Google Star') }}</span>
      </div>
      <div class="popup-item">
        <h4>Chair</h4>
        <input type="text" class="pop-input" v-model="chair" placeholder="Chair" name="Chair" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Chair')">{{ errors.first('Chair') }}</span>
      </div>
      <div class="popup-item">
        <h4>Remaining Lease</h4>
        <input type="text" class="pop-input" v-model="remaining_lease" placeholder="Remaining Lease" name="Remaining Lease" v-validate="'required'"/>
        <span class="text-danger text-sm" v-show="errors.has('Remaining Lease')">{{ errors.first('Remaining Lease') }}</span>
      </div>
      <div class="popup-item">
        <h4>Restaurant Body</h4>
        <textarea class="pop-textarea" placeholder="Body" name="Body"  v-validate="'required'" v-model="description"></textarea>
        <span class="text-danger text-sm" v-show="errors.has('Body')">{{ errors.first('Body') }}</span>
      </div>
      <div class="popup-item">
        <div class="tr-button blue-button popup-button" @click="submitData">{{dataProp ? 'Save' : 'Add New'}} Restaurant</div>
        <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    dataProp: {
      type: Object
    },
    end: {
      type: Function,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      name: '',
      description: '',
      chair: '',
      google_star: '',
      remaining_lease: '',
      location: '',
      id: null,
      restaurants: [],
      selected_restaurants: []
    }
  },
  mounted () {
    if (!this.restaurantlist) {
      this.getUserList()
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) {
        return
      } else if (this.dataProp) {
        const { id, name, description, location, chair, google_star, remaining_lease } = JSON.parse(JSON.stringify(this.dataProp))
        this.id = id
        this.name = name
        this.description = description
        this.location = location
        this.chair = chair
        this.google_star = google_star
        this.remaining_lease = remaining_lease
      }
      return true
    }
  },
  computed: {
    selectedRestaurant () {
      let obj = this.$store.state.api.selectedRestaurant
      if (!obj) {
        try {
          obj = JSON.parse(localStorage.getItem('selectedRestaurant'))
        } catch (e) {
          obj = null
        }
      }
      return obj
    },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    restaurant_select () {
      return this.restaurantlist.map(restaurant => {
        return  {
          label: restaurant.user_property['Restaurant-Name'],
          value: restaurant.id
        }
      })
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlist || JSON.parse(localStorage.getItem('restaurantlist'))
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    multi_select_options () {
      return this.restaurantlist.map(user => {
        const option = {
          label: user.user_property['Restaurant-Name'],
          value: user.id
        }
        return option
      })
    }
  },
  methods: {
    handleFocus () {
      // do something here
    },
    handleFocusOut () {
      // do something here
    },
    initValues () {
      this.name = ''
      this.description = ''
      this.chair = ''
      this.google_star = ''
      this.remaining_lease = ''
      this.location = ''
      this.restaurants = []
      this.selected_restaurants = []
      this.id = null
    },

    getUserList () {
      const payload = {
        user_group: 2
      }

      this.$vs.loading()

      this.$store.dispatch('api/getUserList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          const obj = {
            name: this.name,
            description: this.description,
            location: this.location,
            google_star: this.google_star,
            chair: this.chair,
            remaining_lease: this.remaining_lease,
            id: this.id
          }

          this.$store.dispatch('api/addRestaurantSale', obj).then((response) => {
            this.$vs.notify({
              title: 'Restaurant Saved',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$vs.loading.close()
            this.isSidebarActiveLocal = false
          }).catch(err => {
            console.error(err)
            if (err.message.contains('Restaurant saved')) {
              this.$vs.notify({
                title: 'Content Saved',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
            } else {
              this.$vs.notify({
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            }
            this.$vs.loading.close()
          })

        }
      })
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
  .popup-cont {
    height: auto !important;
    overflow: auto;

    .popup-item {
      .upload-image {

        max-height: 30vh;
        overflow: auto;
      }
    }
  }
</style>
